import React from 'react';
import { EditCustomerState } from './editCustomerState/EditCustomerState';
import { EditCustomerControlPanel } from './components/ControlPanel';
import Forms from './components/Forms/Forms';
import { ModalWindows } from './components/ModalWindows';

const EditCustomerPage: React.FC = () => {
	return (
		<EditCustomerState>
			<EditCustomerControlPanel />
			<Forms />
			<ModalWindows />
		</EditCustomerState>
	);
};

export default EditCustomerPage;
